<template>
  <div>
    <BaseHeader />
    <div class="container-fluid">
      <div class="row mt-5" v-if="!isExp">
        <div class="col-lg-6 mb-5">
          <SideLeft />
        </div>
        <div class="col-lg-6">
          <div v-if="!section">
            <div class="card-v3">
              <h2>{{ text.paymentType }}</h2>
              <div class="payment-list">
                <div v-for="(pm, index) in payment_methods" :key="index">
                  <label
                    :class="{
                      text_deactive: pm.disabled,
                      'container-radio': true,
                    }"
                  >
                    <div class="row">
                      <div class="col-md-6">
                        {{ pm.description }}
                      </div>
                      <div class="col-md-6">
                        <div style="margin-left: 8px" v-html="pm.icon"></div>
                        <input
                          type="radio"
                          name="payment-choice"
                          :value="pm.paymentType"
                          :disabled="pm.disabled"
                          v-model="selectedMethod"
                        />
                        <span class="checkmark-radio"></span>
                      </div>
                    </div>
                  </label>
                  <hr v-if="index != payment_methods.length - 1" />
                </div>
              </div>
            </div>

            <button
              type="submit"
              :disabled="!selectedMethod"
              @click="set_section()"
            >
              {{ text.nextButton }}
            </button>

            <!-- <v-btn
                      :to="route"
                      block
                      round
                      large
                      color="primary"
                      :disabled="!selectedMethod"   
                    >
                      {{ text.nextButton }}
                    </v-btn> -->
          </div>

          <div
            v-if="
              section &&
              paymentGroup1.includes(selectedMethod) &&
              paymentBy.length > 0
            "
          >
            <div class="card-v3">
              <h2>{{ text.paymentBy }}</h2>
              <div class="payment-list">
                <div class="row">
                  <div class="col-md-6 text-end">
                    <h4>{{ paymentBy[0].description }}</h4>
                  </div>
                  <div class="col-md-6">
                    <div
                      style="margin-left: 8px"
                      v-html="paymentBy[0].icon"
                    ></div>
                  </div>
                </div>

                <div style="text-align: center" class="mt-4 mb-4">
                  <a href="#" @click="section = ''">{{
                    text.changePaymentMethod
                  }}</a>
                </div>

                <!-- qr code -->
                <div
                  v-if="paymentGroup1.includes(selectedMethod)"
                  class="row"
                  style="margin: 0px; background: #ddd"
                >
                  <div class="col-md-4 offset-md-4 mt-4 mb-4">
                    <v-img :src="qrcode" />
                  </div>
                </div>
              </div>

              <br />
              <!-- payment detail -->
              <div class="card-v2">
                <div class="card-head-v2" style="padding: 37px 23px 25px 23px">
                  <div class="row">
                    <div class="col-6 lable">
                      <h2>{{ text.amountTotal }}</h2>
                    </div>
                    <div class="col-6 text-end info">
                      <h2>
                        <strong>฿ {{ amount }}</strong>
                      </h2>
                    </div>
                  </div>
                </div>
                <!-- <div class="card-body-v2"> 
                            <div class="row">
                                <div class="col-6 lable">{{ text.amountTotal }}</div>
                                <div class="col-6 text-end info"><strong>{{ amount }}</strong></div>
                            </div> 
                        </div> -->
              </div>
              <!-- <Paying :to="`/paymentInput/${this.selectedMethod}`"></Paying> -->
            </div>
            <button class="btn-download" @click="downloadQR()">
              {{ text.btndownloadQR }}
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-else>
        <div class="col-lg-6 offset-lg-3">
          <div class="card-v2">
            <div class="card-head-v2">
              <p class="text-center pm-amount">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="11" cy="11" r="11" fill="#AB2328" />
                  <path
                    d="M9.992 17V9H12.136V17H9.992ZM9.992 7.976V5.8H12.136V7.976H9.992Z"
                    fill="white"
                  />
                </svg>
                {{ text.linkExp }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.v-input__slot {
  margin-bottom: 0px !important;
}
.remark {
  margin-bottom: 20px;
  color: #004071;
}
</style>
<script>
import * as moment from 'moment'
import { mapState } from 'vuex'
import domtoimage from 'dom-to-image'
export default {
  mounted() {
    // check Expire date
    let checkExpire = setInterval(() => {
      if (sessionStorage.getItem('linkcode')) {
        const exp = moment(this.$store.state.expire).toDate()
        if (exp.getTime() <= new Date().getTime()) {
          this.isExp = true
          this.dialog = true
          clearInterval(checkExpire)
        }
      }
    }, 10000)
    const linkcodes = this.$route.query.linkcode.split('?')
    this.$route.query.linkcode = linkcodes[0]
    this.$store.dispatch('getBillData', this.$route.query.linkcode)

    this.checkData()
  },
  data() {
    return {
      selectedMethod: null,
      isExp: false,
      dialog: false,
      section: '',
      /*
      ThaiQR        /qr/ThaiQR/?linkcode=LETOLE,
      CreditCard    /paymentInput/CreditCard/?linkcode=LETOLE,
      CreditUnion   /credit/CreditUnion/?linkcode=LETOLE,
      CreditQR      /qr/CreditQR/?linkcode=LETOLE,
      WeChat        /qr/WeChat/?linkcode=LETOLE,
      Alipay        /qr/Alipay/?linkcode=LETOLE,
      SCB Easy      
      */
      paymentBy: {},
      paymentGroup1: ['ThaiQR', 'CreditQR', 'WeChat', 'Alipay'],
      paymentGroup2: ['CreditCard', 'CreditUnion'],
      paymentGroup3: ['SCB Easy'],
    }
  },
  created() {
    this.getBanks()
  },
  methods: {
    set_section() {
      this.loading = true
      this.section = this.selectedMethod

      this.paymentBy = this.payment_methods.filter((res) => {
        return res.paymentType == this.selectedMethod
      })

      if (this.paymentGroup1.includes(this.selectedMethod)) {
        this.genQr()
      } else if (this.paymentGroup2.includes(this.selectedMethod)) {
        window.location.href = this.route
        // window.location.href = '/paymentInput/CreditCard/?linkcode='+this.$route.query.linkcode;
      } else if (this.paymentGroup3.includes(this.selectedMethod)) {
        //SCB Easy
      }
    },

    genQr() {
      let billStatus = setInterval(() => {
        this.$store
          .dispatch('getBillDataStatus', this.$route.query.linkcode)
          .then(() => {
            if (this.$store.state.billDataStatus != 2) {
              let page =
                this.$store.state.billDataStatus <= 3
                  ? 'paymentMethods'
                  : 'billRecieve'
              clearInterval(billStatus)
              this.$router.push(
                `/${page}/?linkcode=${this.$route.query.linkcode}`
              )
            }
          })
      }, 30000)
      if (this.$store.state.billBank) {
        var bank = this.$store.state.billBank.filter((item) => {
          return item.paymentType == this.selectedMethod
        })
        if (bank.length > 0) {
          let qr = {}
          switch (this.selectedMethod) {
            case 'CreditQR':
              this.method = 'คิวอาร์ เครดิต'
              break
            case 'ThaiQR':
              this.method = 'คิวอาร์ เพย์เมนต์'
              break
            case 'WeChat':
              this.method = 'WeChat Pay'
              qr.trantype = 'W'
              break
            case 'Alipay':
              this.method = 'Ali Pay'
              qr.trantype = 'A'
              break
          }
          qr.method = this.selectedMethod
          qr.refcode = this.$store.state.linkcode
          qr.amount = this.$store.state.amount
          qr.bubankid = bank[0].id
          qr.updateQr = this.$store.state.qr
          this.$store.dispatch('getQR', qr)
        }
      } else {
        this.$router.push(
          '/paymentMethods/?linkcode=' + this.$route.query.linkcode
        )
      }
      this.loading = false
    },
    downloadQR() {
      const element = document.querySelector('.v-input__append-inner')
      element.style.display = 'none'

      this.loading = true
      domtoimage
        .toJpeg(document.getElementById('screenshot'), {
          quality: 0.95,
        })
        .then((dataUrl) => {
          var link = document.createElement('a')
          let urlString = window.location.href
          link.download = urlString.split('?')[1].split('=')[1] + '.jpg'
          link.href = dataUrl
          link.click()
          this.loading = false
          element.style.display = 'flex'
        })
    },

    checkData() {
      if (sessionStorage.getItem('linkcode')) {
        const exp = moment(this.$store.state.expire).toDate()
        if (exp.getTime() <= new Date().getTime()) {
          this.isExp = true
          this.dialog = true
        } else if (this.$store.state.billData.status > 3) {
          this.$router.push(
            `/billRecieve/?linkcode=${this.$route.query.linkcode}`
          )
        }
        if (this.$store.state.billBank.length == 1) {
          this.nextSkip()
        }
      } else {
        this.$router.push(`/authen/?linkcode=${this.$route.query.linkcode}`)
      }
    },
    onLinkExpire() {
      this.$router.push(`/authen/?linkcode=${this.$route.query.linkcode}`)
    },
    getBanks() {
      if (this.$store.state.billBank) {
        let banks = this.$store.state.billBank
        this.selectedMethod = banks[0].paymentType
      }
    },
    nextSkip() {
      if (this.billBank.length) {
        let path = ''
        let banks = this.$store.state.billBank
        let selectedBank = banks.filter((bank) => {
          return bank.paymentType == this.selectedMethod
        })[0]
        if (selectedBank) {
          if (selectedBank.splitCard) {
            path = 'paymentInput'
          } else if (selectedBank.paymentType === 'SCB Easy') {
            path = 'scbeasy'
          } else {
            if (
              selectedBank.paymentType == 'CreditCard' ||
              selectedBank.paymentType == 'CreditUnion'
            ) {
              path = 'credit'
            } else {
              path = 'qr'
            }
            this.$store.commit('MAX_AMOUNT')
          }
          this.$store.commit('SELECTED_METHOD', selectedBank.id)
        }
        this.$router.push(
          `/${path}/${this.selectedMethod}/?linkcode=${this.$route.query.linkcode}`
        )
      }
    },
  },
  computed: {
    qrcode() {
      if (!this.$store.state.qr) return require('@/assets/no_img.png')
      return this.$store.state.qr
    },

    ...mapState({
      billBank: (state) => state.billBank,
    }),
    titlePaymentType() {
      return this.$options.filters.dbTextDisplay('PaymentType')
    },
    payment_methods() {
      if (this.$store.state.billBank) {
        let banks = this.$store.state.billBank
        let isiOS =
          navigator.userAgent.match('iPad') ||
          navigator.userAgent.match('iPhone') ||
          navigator.userAgent.match('iPod')
        let isAndroid = navigator.userAgent.match('Android')
        banks.forEach((bank) => {
          bank.disabled = false
          if (this.$store.state.language == 'EN') {
            bank.description = bank.description_en
          } else {
            bank.description = bank.description_th
          }
          switch (bank.paymentType) {
            case 'CreditCard':
              bank.icon = `<img src="${require('../assets/ic_Master.png')}" height="20"/>&nbsp;&nbsp;<img src="${require('../assets/Ic_Visa.png')}" height="20"/>&nbsp;<img src="${require('../assets/ic_Jcb.svg')}" height="20"/>`
              break
            case 'CreditUnion':
              bank.icon = `<img src="${require('../assets/Ic_Union.svg')}" height="20"/>`
              break
            case 'CreditQR':
              bank.icon = `<img src="${require('../assets/ic_QR.svg')}" height="20"/>`
              break
            case 'ThaiQR':
              bank.icon = `<img src="${require('../assets/thai_qr.png')}" height="20"/>&nbsp;&nbsp;<img src="${require('../assets/prompt_pay.png')}" height="20"/>`
              break
            case 'WeChat':
              bank.icon = `<img src="${require('../assets/Ic_WeChat.svg')}" height="20"/>`
              break
            case 'Alipay':
              bank.icon = `<img src="${require('../assets/ic_Alipay.svg')}" height="20"/>`
              break
            case 'SCB Easy':
              bank.disabled = !(isiOS || isAndroid)
              bank.icon = `<img src="${require('../assets/ic_scb_easy.jpg')}" height="20"/>`
              break
          }
        })
        return banks
      } else {
        return []
      }
    },
    isSplitPaid() {
      if (
        this.$store.state.billData &&
        this.$store.state.billData.paid > 0 &&
        this.$store.state.billData.outstanding > 0
      ) {
        return true
      } else {
        return false
      }
    },
    route() {
      if (this.$store.state.billBank) {
        let path = ''
        let banks = this.$store.state.billBank
        let selectedBank = banks.filter((bank) => {
          return bank.paymentType == this.selectedMethod
        })[0]
        if (selectedBank) {
          if (selectedBank.splitCard) {
            path = 'paymentInput'
          } else if (selectedBank.paymentType === 'SCB Easy') {
            path = 'scbeasy'
          } else {
            if (
              selectedBank.paymentType == 'CreditCard' ||
              selectedBank.paymentType == 'CreditUnion'
            ) {
              path = 'credit'
            } else {
              path = 'qr'
            }
            this.$store.commit('MAX_AMOUNT')
          }
          this.$store.commit('SELECTED_METHOD', selectedBank.id)
        }
        return `/${path}/${this.selectedMethod}/?linkcode=${this.$route.query.linkcode}`
      }
      return '/'
    },

    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          paymentType: 'Payment Type',
          nextButton: 'Next',
          linkExp: 'This link expire.',
          paymentBy: 'Pay through',
          changePaymentMethod: 'Change payment method',
          btndownloadQR: 'Save QR ',
          amountTotal: 'Total ',
          amountTotal: 'Total ',
        }
      } else {
        obj = {
          paymentType: 'เลือกวิธีการชำระเงิน',
          nextButton: 'ดำเนินการต่อ',
          linkExp: 'ลิงค์ชำรเงินนี้หมดอายุแล้ว',
          paymentBy: 'ชำระผ่าน',
          changePaymentMethod: 'เปลี่ยนวิธีการชำระเงิน',
          btndownloadQR: 'บันทึกคิวอาร์โค้ด',
          amountTotal: 'ยอดรวม',
        }
      }
      return obj
    },

    amount() {
      return this.$store.state.total
      return this.twoDecimal(this.$store.state.amount)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    outstanding() {
      return this.twoDecimal(
        this.$store.state.outstanding - this.$store.state.amount
      )
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
</script>
